import { render, staticRenderFns } from "./ScrollingDocument.vue?vue&type=template&id=00c0a205&scoped=true"
import script from "./ScrollingDocument.vue?vue&type=script&lang=ts"
export * from "./ScrollingDocument.vue?vue&type=script&lang=ts"
import style0 from "./ScrollingDocument.vue?vue&type=style&index=0&id=00c0a205&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c0a205",
  null
  
)

export default component.exports